import React, { useRef, useEffect } from 'react';
import '../../styles/componentStyle/workers-ccus-connecting-dialog.scss';
import { messageUtility } from '../../utilities/messageUtility';

export const CcusConnectingDialog = () => {
  const dialogRef = useRef(null);
  useEffect(() => {
    dialogRef.current.focus();
  }, []);

  return (
    <div className={'modal show'}>
      <div className='dialog-sm dialog--modal'>
        <div className='dialog-sm__body ccus-connecting-dialog'>
          <div className='ccus-connecting-dialog__indicater'>
            <span className='ccus-connecting-indicater'>Loading…</span>
          </div>
          <div className='ccus-connecting-dialog__message' ref={dialogRef}>
            <p>{messageUtility.getMessage('I-002-005-07')}</p>
            <p>{messageUtility.getMessage('I-002-005-08')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/modals/CcusConnectingDialog.jsx